jQuery(document).ready(function(){
    initBrowserCheck();
    initSlickCarousel();
    google();
    nav();
    // iconswitch();
});

// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if ( isIE() ) {
        jQuery('.notice-browser').show();
    }
}

// Init Slick Carousel
function initSlickCarousel() {
    jQuery('.slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesPerRow: 1,
        rows: 1,
    });
    jQuery('.frontpage-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesPerRow: 1,
        rows: 1,
    });
}


function google() {
    jQuery(".map")
        .on("click", function() {
            jQuery(".google iframe").attr("src", jQuery(".google iframe").attr("src").replace("", "https://maps.google.com/maps?width=100%25&height=600&hl=en&q=Oberer%20Luessbach%209%2082335%20Berg-Hoehenrain+(My%20Business%20Name)&t=&z=13&ie=UTF8&iwloc=B&output=embed"));
            jQuery(".map").css("display", "none");
        });
}

function nav() {
    jQuery('.nav-toggle').on('click', function() {
        jQuery('#nav-icon').toggleClass('open');
        jQuery('.mobile-nav').toggleClass('show_nav');
        jQuery('body').toggleClass('mobile_overflow');
    });
}

function iconswitch() {
    jQuery(".machinepark-wrapper .machine")
        .on("mouseenter", function() {
            jQuery(this).find('img').attr("src", jQuery(this).find('img').attr("src").replace("weiss.svg", "weiss-hover.svg"));
        })
        .on("mouseleave", function() {
            jQuery(this).find('img').attr("src", jQuery(this).find('img').attr("src").replace("weiss-hover.svg", "weiss.svg"));
        });
}